import { siteConfig } from "@/lib/utils";

type NavLink = {
  label: string;
  href: string;
};

export const primaryNav: ReadonlyArray<NavLink> = [
  { label: "Lösung", href: "/#solution" },
  { label: "Preise", href: "/#pricing" },
  // TODO: build a real FAQ section/page; for now this anchor target does not yet exist.
  { label: "FAQ", href: "/#faq" },
  { label: "Über uns", href: "/team" },
  { label: "Login", href: "https://dashboard.clarusplus.com/auth/login" },
] as const;

export const primaryCta: NavLink = {
  label: "Kostenlos starten",
  href: "https://dashboard.clarusplus.com/auth/register",
};

/**
 * Many of these footer destinations don't have dedicated pages yet — they
 * fall back to homepage anchors or `#`. Replace `href: "#"` once the
 * corresponding page or section exists.
 */
export const footerColumns: ReadonlyArray<{
  title: string;
  links: ReadonlyArray<NavLink>;
}> = [
  {
    title: "Produkt",
    links: [
      { label: "Lösung", href: "/#solution" },
      { label: "Preise", href: "/#pricing" },
      { label: "Changelog", href: "/changelog" },
    ],
  },
  {
    title: "Ressourcen",
    links: [
      { label: "Dokumentation", href: "/dokumentation" },
      { label: "Blog", href: "/blog" },
    ],
  },
  {
    title: "Unternehmen",
    links: [
      { label: "Über uns", href: "/team" },
      { label: "Karriere", href: "/karriere" },
    ],
  },
  {
    title: "Support",
    links: [
      { label: "Kontakt", href: "/kontakt" },
      { label: "FAQ", href: "/faq" },
    ],
  },
] as const;

export const socialLinks: ReadonlyArray<{
  label: string;
  href: string;
  icon: "linkedin" | "instagram" | "tiktok";
}> = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/clarusplus/",
    icon: "instagram",
  },
  {
    label: "LinkedIn",
    href: "https://de.linkedin.com/showcase/clarusplus/",
    icon: "linkedin",
  },
] as const;

export const subFooterLinks: ReadonlyArray<NavLink> = [
  { label: "Impressum", href: "/impressum" },
  { label: "Datenschutz", href: "/datenschutz" },
  { label: "AGB", href: "/agb" },
  { label: "Cookie-Einstellungen", href: "#" },
] as const;

export const footerTagline =
  "Digitale Barrierefreiheit — einfach, messbar, rechtssicher. Wir helfen Unternehmen, BFSG-konform zu werden.";

// Legal entity comes from the single source of truth in siteConfig (same
// value used in the Impressum and JSON-LD) so it never drifts. The footer
// drops the "(haftungsbeschränkt)" suffix for brevity — the full legal name
// still appears in the Impressum, where it is legally required (§ 5a GmbHG).
export const footerCopyright = `© 2026 ${siteConfig.companyLegal.replace(/\s*\(haftungsbeschränkt\)/, "")} · Alle Rechte vorbehalten`;
